<mat-form-field class="flex-auto gt-xs:pr-3">
  <mat-label>Deal Layout</mat-label>
  <mat-select [disabled]="readonly" data-cy="deal-template-field" [formControl]="template_id" placeholder="--Select--">
    <mat-option *ngFor="let projectTemplate of dataSource" [value]="projectTemplate.id">
      {{ projectTemplate.name }}
    </mat-option>
  </mat-select>
</mat-form-field>
